<div class="wrapper">
  <!-- <div class="top-btns">
    <button [routerLink]="[ '/login' ]" style="margin-right: 15px;" routerLinkActive="active"
      class="btn btn-lg btn-outline-primary">Sign In</button>
  </div> -->
  <!-- <div class="top-btns">
    <a style="padding-right: 10px; margin-right: 10px; width: 100px" data-aos="fade-up"
      data-aos-anchor-placement="bottom-bottom" [routerLink]="[ '/login' ]" routerLinkActive="active"
      class="btn btn-orange banner-btn">Log in</a>
  </div> -->
  <div class="show-video-bg">
    <div class="video-wrapper">
      <!-- <video class="video-banner" loop="true" autoplay muted oncanplay="this.play()"
             onloadedmetadata="this.muted = true">
        <source src="./assets/videos/banner-video.mp4" type="video/mp4" />
      </video> -->
    </div>
    <div class="container">
      <div class="logo" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom">
        <div>
        </div>
      </div>
      <div class="user-block">
        <div class="dropdown">
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <div class="user-name">
            </div>
            <ul>
              <li class="subscription-menu">
                <a [routerLink]="[ '/dashboard' ]" routerLinkActive="active">Subscription</a>
              </li>
              <li class="account-setting-menu">
                <a>Account Settings</a>
              </li>
              <li class="logout-menu pointer">
                <a (click)="logOut();">Log Out</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="banner">
        <h5 data-aos="fade-up" data-aos-anchor-placement="bottom-bottom">
          <strong>Introducing EXTREME SECURITY for communications</strong>
        </h5>

        <h5 data-aos="fade-up" data-aos-anchor-placement="bottom-bottom">
          <strong>QUANTUM RESISTANT ENCRYPTION™</strong>
        </h5>

        <div id="bump">

        </div>

        <h5 class="subscribe" style="padding-bottom: 10px;" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom">
          SUBSCRIBE
        </h5>
        <h2 id="planCards" style="padding-bottom: 10px!important;" class="plan-tile-label" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom">
          Prices are per user per month.
        </h2>
        <section style="padding:0px !important;">
          <div class="grid-plan-two-tiles section3">
            <div class="grid-plan-two-tile clickable-tile"
                 (click)="autopopulatePlanIndividual(); router.navigate(['/signup-embedded'])">
              <h3 class="general-font-size" style="margin-top:10px;"><span>Individual</span></h3>
              <div></div>
              <ul class="checkmark-list">
                <li>$6</li>
              </ul>
            </div>

            <div class="grid-plan-two-tile clickable-tile"
                 (click)="autopopulatePlanFamily(); router.navigate(['/signup-embedded'])">
              <h3 class="general-font-size" style="margin-top:10px;"><span>2-4 users</span></h3>
              <ul class="checkmark-list">
                <li>$5</li>
              </ul>
            </div>

            <div class="grid-plan-two-tile clickable-tile"
                 (click)="autopopulatePlanSmallBusiness(); router.navigate(['/signup-embedded'])">
              <h3 class="general-font-size" style="margin-top:10px;"><span>5-50 users</span></h3>
              <ul class="checkmark-list">
                <li>$4</li>
              </ul>
            </div>

            <div class="grid-plan-two-tile clickable-tile"
                 (click)="autopopulatePlanMidBusiness(); router.navigate(['/signup-embedded'])">
              <h3 class="general-font-size" style="margin-top:10px;"><span>51-300 users</span></h3>
              <ul class="checkmark-list">
                <li>$3</li>
              </ul>
            </div>

            <div class="grid-plan-two-tile clickable-tile"
                 (click)="autopopulatePlanEnterprise(); router.navigate(['/signup-embedded'])">
              <h3 class="general-font-size" style="margin-top:10px;"><span>301-unlimited users</span></h3>
              <ul class="checkmark-list">
                <li>$2</li>
              </ul>
            </div>

          </div>

        </section>
        <h2 id="planCards" class="plan-tile-label" data-aos="" data-aos-anchor-placement="bottom-bottom">
          Subscriptions are subject to <a style="color:white!important" href="https://www.titaniumsecure.io/service-aggrement" target="_blank">Terms of Use</a>.
        </h2>

      </div>
    </div>
  </div>
</div>
